import { composeIO } from 'react-compose-io'
import { informacoesIniciaisPedidoIO } from './InformacoesIniciaisPedido.IO'
import { InformacoesIniciaisPedidoView } from './InformacoesIniciaisPedido.View'

export const InformacoesIniciaisPedido = composeIO(InformacoesIniciaisPedidoView, informacoesIniciaisPedidoIO)
